import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { trigger, state, animate, transition, style, query, group, stagger } from '@angular/animations';

export const routerTransition = trigger('routerTransition', [
  transition('void => listing', [
    // Initial state of new route
    query(':enter, :leave', style({ position: 'fixed', width: '100%', })),
    // Vertical page load
    group([
      query(':enter', [
        style({ transform: 'translateY(25%)', opacity: '0' }),
        animate('1000ms cubic-bezier(.35,0,.25,1)', style({ transform: 'translateY(0%)', opacity: '1' }))
      ], { optional: true }),
      query(':leave', [
        style({ opacity: '1' }),
        animate('500ms cubic-bezier(.35,0,.25,1)', style({ opacity: '0' }))
      ], { optional: true }),
    ]),
  ]),

   // Next Page
   transition('* => next', [
    // Initial state of new route
    query(':enter, :leave', style({ position: 'fixed', width: '100%', })),
    // Hortizontal right to left page load
    group([
      query(':enter', [
        style({ transform: 'translateX(100%)', opacity: '0' }),
        animate('0.5s ease-in-out', style({ transform: 'translateX(0%)', opacity: '1' }))
      ], { optional: true }),
      query(':leave', [
        style({ transform: 'translateX(0%)', opacity: '1' }),
        animate('0.5s ease-in-out', style({ transform: 'translateX(-100%)', opacity: '0' }))
      ], { optional: true }),
    ]),
  ]),

  // Subsequent pages back to listing page
  
  transition('next => listing', [
      // Initial state of new route
    query(':enter, :leave', style({ position: 'fixed', width: '100%' })),
    // {optional:true}),
    // Hortizontal left to right page load
    group([
      query(':enter', [
        style({ transform: 'translateX(-100%)', opacity: '0' }),
        animate('0.5s ease-in-out', style({ transform: 'translateX(0%)', opacity: '1' }))
      ], { optional: true }),
      query(':leave', [
        style({ transform: 'translateX(0%)', opacity: '1' }),
        animate('0.5s ease-in-out', style({ transform: 'translateX(100%)', opacity: '0' }))
      ], { optional: true }),
    ]),
  ]),
   
  // Next Page
  transition('void => next', [
    // Initial state of new route
    query(':enter, :leave', style({ position: 'fixed', width: '100%', })),
    // Hortizontal animations right to left page load
    group([
      query(':enter', [
        style({ transform: 'translateX(100%)', opacity: '0' }),
        animate('0.5s ease-in-out', style({ transform: 'translateX(0%)', opacity: '1' }))
      ], { optional: true }),
      query(':leave', [
        style({ transform: 'translateX(0%)', opacity: '1' }),
        animate('0.5s ease-in-out', style({ transform: 'translateX(-100%)', opacity: '0' }))
      ], { optional: true }),
    ]),
  ]),

  // Next Page to Checkout
  transition('next => checkout', [
    // Initial state of new route
    query(':enter, :leave', style({ position: 'fixed', width: '100%', })),
    // Hortizontal animations right to left page load
    group([
      query(':enter', [
        style({ transform: 'translateX(100%)', opacity: '0' }),
        animate('0.5s ease-in-out', style({ transform: 'translateX(0%)', opacity: '1' }))
      ], { optional: true }),
      query(':leave', [
        style({ transform: 'translateX(0%)', opacity: '1' }),
        animate('0.5s ease-in-out', style({ transform: 'translateX(-100%)', opacity: '0' }))
      ], { optional: true }),
    ]),
  ]),
])




// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/animations/router.animations.ts